// 因为后端following_count包含了所有的关注数量，但是关注页不会把领域、专题、主题纳入到关注流中所以需要减去
export default function getFollowPageFollowingCount(user) {
  return (
    user?.following_count -
    user?.job_following_count -
    user?.explore_following_count -
    user?.topic_following_count
  );
}
